<template>
 <div id="app">
  <div class="form__field">
   <div class="cell">
    <input @keyup.enter="queryResults" class="ids_topicSearch" id="ctl00_ids_contentPlaceHolder_ids_topicSearch" name="ctl00$ids_contentPlaceHolder$ids_topicSearch" placeholder="Search Contents" type="text" v-model="search"/>
   </div>
   <div class="search_button" v-if="search">
    <button @click="clearResult" class="close-icon">
     &times;
    </button>
   </div>
   <div class="search_button">
    <button @click="queryResults">
     <i class="fa fa-search">
     </i>
    </button>
   </div>
  </div>
  <div class="col-1 l-pad-top" id="results">
   <div>
    <p class="toc-2-style" style="margin-bottom: 10px;">
     <strong v-if="resultsCount != 0">
      ({{resultsCount}}) Results Found
     </strong>
     <strong v-else-if="resultsActual">
      No Results Found
     </strong>
    </p>
   </div>
   <div v-for="result of resultsActual">
    <p class="toc-2-style">
     <a :href="result.link" :keywords="result.keywords" onclick="reload(this.href, this.getAttribute('keywords'))">
      {{result.title}}
     </a>
    </p>
    <p class="toc-3-style">
     {{result.desc}}
    </p>
   </div>
  </div>
  <div class="side-toc" v-if="!resultsActual">
   <p class="toc-1-style">
    <a href="cover.html" title="M3250-, MS622-tulostimet">
     M3250-, MS622-tulostimet
    </a>
   </p>
   <p class="toc-1-style">
    <a href="safety.html#safety_fi" title="Turvaohjeita">
     Turvaohjeita
    </a>
   </p>
   <div id="divd0e18">
    <p class="toc-2-style">
     <a href=".html#d0e23" title="Merkint&auml;tavat">
      Merkint&auml;tavat
     </a>
    </p>
    <p class="toc-2-style">
     <a href="safety-power-cord-topic.html#d0e42" title="Tuotelausunnot">
      Tuotelausunnot
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="learning-about-printer-chapter.html#learning-about-printer-chapter_fi" title="Tietoja tulostimesta">
     Tietoja tulostimesta
    </a>
   </p>
   <div id="divd0e179">
    <p class="toc-2-style">
     <a href="finding-information-about-printer-topic.html#finding-information-about-printer_fi" title="Tulostintietojen etsiminen">
      Tulostintietojen etsiminen
     </a>
    </p>
    <p class="toc-2-style">
     <a href="selecting-location-printer-m-topic.html#selecting-location-printer-m_fi" title="Tulostimen paikan valitseminen">
      Tulostimen paikan valitseminen
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printer-configurations-topic.html#printer-configurations_fi" title="Tulostinkokoonpanot">
      Tulostinkokoonpanot
     </a>
    </p>
    <p class="toc-2-style">
     <a href="attaching-cables-topic.html#attaching-cables_fi" title="Kaapelien liitt&auml;minen">
      Kaapelien liitt&auml;minen
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-control-panel-topic.html#using-control-panel_fi" title="Ohjauspaneelin k&auml;ytt&auml;minen">
      Ohjauspaneelin k&auml;ytt&auml;minen
     </a>
    </p>
    <p class="toc-2-style">
     <a href="understanding-status-of-power-button-and-indicator-light-topic.html#understanding-status-of-power-button-and-indicator-light_fi" title="Virtapainikkeen valon ja merkkivalon tilan merkitys">
      Virtapainikkeen valon ja merkkivalon tilan merkitys
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-network-setup-page-topic.html#printing-network-setup-page_fi" title="Verkkoasetussivun tulostus">
      Verkkoasetussivun tulostus
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="setting-up-using-home-screen-apps-chapter.html#setting-up-using-home-screen-apps-chapter_fi" title="Aloitusn&auml;yt&ouml;n sovellusten asentaminen ja k&auml;ytt&auml;minen">
     Aloitusn&auml;yt&ouml;n sovellusten asentaminen ja k&auml;ytt&auml;minen
    </a>
   </p>
   <div id="divd0e746">
    <p class="toc-2-style">
     <a href="using-home-screen-topic.html#using-home-screen_fi" title="Aloitusn&auml;yt&ouml;n k&auml;ytt&auml;minen">
      Aloitusn&auml;yt&ouml;n k&auml;ytt&auml;minen
     </a>
    </p>
    <p class="toc-2-style">
     <a href="customizing-home-screen-topic.html#customizing-home-screen_fi" title="Aloitusn&auml;yt&ouml;n mukauttaminen">
      Aloitusn&auml;yt&ouml;n mukauttaminen
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-display-customization-topic.html#using-display-customization_fi" title="N&auml;yt&ouml;n mukauttaminen">
      N&auml;yt&ouml;n mukauttaminen
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-eco-settings-topic.html#configuring-eco-settings_fi" title="Ymp&auml;rist&ouml;asetusten m&auml;&auml;ritt&auml;minen">
      Ymp&auml;rist&ouml;asetusten m&auml;&auml;ritt&auml;minen
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-customer-support-topic.html#using-customer-support_fi" title="Asiakastuen k&auml;ytt&auml;minen">
      Asiakastuen k&auml;ytt&auml;minen
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-qr-code-generator-topic.html#using-qr-code-generator_fi" title="QR-koodin luontitoiminnon k&auml;ytt&auml;minen">
      QR-koodin luontitoiminnon k&auml;ytt&auml;minen
     </a>
    </p>
    <p class="toc-2-style">
     <a href="setting-up-device-quotas-topic.html#setting-up-device-quotas_fi" title="Laitekiinti&ouml;iden m&auml;&auml;ritt&auml;minen">
      Laitekiinti&ouml;iden m&auml;&auml;ritt&auml;minen
     </a>
    </p>
    <p class="toc-2-style">
     <a href="creating-cloud-connector-profile-topic.html#creating-cloud-connector-profile_fi" title="Cloud Connector -profiilin luominen">
      Cloud Connector -profiilin luominen
     </a>
    </p>
    <p class="toc-2-style">
     <a href="creating-bookmarks-topic.html#d0e1092" title="Kirjanmerkkien hallinta">
      Kirjanmerkkien hallinta
     </a>
    </p>
    <p class="toc-2-style">
     <a href="adding-contacts-topic.html#d0e1169" title="Yhteystietojen hallinta">
      Yhteystietojen hallinta
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="setting-up-using-accessibility-features-chapter.html#setting-up-using-accessibility-features-chapter_fi" title="Helppok&auml;ytt&ouml;toimintojen k&auml;ytt&ouml;&ouml;nottaminen ja k&auml;ytt&auml;minen">
     Helppok&auml;ytt&ouml;toimintojen k&auml;ytt&ouml;&ouml;nottaminen ja k&auml;ytt&auml;minen
    </a>
   </p>
   <div id="divd0e1288">
    <p class="toc-2-style">
     <a href="activating-voice-guidance-topic.html#activating-voice-guidance_fi" title="&Auml;&auml;niohjauksen aktivoiminen">
      &Auml;&auml;niohjauksen aktivoiminen
     </a>
    </p>
    <p class="toc-2-style">
     <a href="navigating-screen-using-gestures-topic.html#navigating-screen-using-gestures_fi" title="Siirtyminen n&auml;yt&ouml;ss&auml; eleill&auml;">
      Siirtyminen n&auml;yt&ouml;ss&auml; eleill&auml;
     </a>
    </p>
    <p class="toc-2-style">
     <a href="enabling-magnification-mode-topic.html#enabling-magnification-mode_fi" title="Suurennustilan ottaminen k&auml;ytt&ouml;&ouml;n">
      Suurennustilan ottaminen k&auml;ytt&ouml;&ouml;n
     </a>
    </p>
    <p class="toc-2-style">
     <a href="adjusting-voice-guidance-speech-rate-topic.html#adjusting-voice-guidance-speech-rate_fi" title="&Auml;&auml;niohjauksen puhenopeuden s&auml;&auml;t&auml;minen">
      &Auml;&auml;niohjauksen puhenopeuden s&auml;&auml;t&auml;minen
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-keyboard-on-display-topic.html#using-keyboard-on-display_fi" title="N&auml;ytt&ouml;n&auml;pp&auml;imist&ouml;n k&auml;ytt&auml;minen">
      N&auml;ytt&ouml;n&auml;pp&auml;imist&ouml;n k&auml;ytt&auml;minen
     </a>
    </p>
    <p class="toc-2-style">
     <a href="enabling-spoken-passwords-or-personal-identifcation-numbers-topic.html#enabling-spoken-passwords-or-personal-identifcation-numbers_fi" title="Luettujen salasanojen tai henkil&ouml;kohtaisten PIN-koodien ottaminen k&auml;ytt&ouml;&ouml;n">
      Luettujen salasanojen tai henkil&ouml;kohtaisten PIN-koodien ottaminen k&auml;ytt&ouml;&ouml;n
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="loading-paper-and-specialty-media-chapter.html#loading-paper-and-specialty-media-chapter_fi" title="Paperin ja erikoismateriaalin lis&auml;&auml;minen">
     Paperin ja erikoismateriaalin lis&auml;&auml;minen
    </a>
   </p>
   <div id="divd0e1493">
    <p class="toc-2-style">
     <a href="setting-paper-size-and-type-topic.html#setting-paper-size-and-type_fi" title="Paperilajin ja -koon m&auml;&auml;ritt&auml;minen">
      Paperilajin ja -koon m&auml;&auml;ritt&auml;minen
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-universal-paper-settings-m-topic.html#configuring-universal-paper-settings-m_fi" title="Universal-paperiasetusten m&auml;&auml;ritt&auml;minen">
      Universal-paperiasetusten m&auml;&auml;ritt&auml;minen
     </a>
    </p>
    <p class="toc-2-style">
     <a href="loading-trays-topic.html#loading-trays_fi" title="Lokeroiden t&auml;ytt&auml;minen">
      Lokeroiden t&auml;ytt&auml;minen
     </a>
    </p>
    <p class="toc-2-style">
     <a href="loading-multipurpose-feeder-topic.html#loading-multipurpose-feeder_fi" title="Monisy&ouml;tt&ouml;laitteen t&auml;ytt&ouml;">
      Monisy&ouml;tt&ouml;laitteen t&auml;ytt&ouml;
     </a>
    </p>
    <p class="toc-2-style">
     <a href="linking-and-unlinking-trays-topic.html#linking-and-unlinking-trays_fi" title="Lokeroiden yhdist&auml;minen">
      Lokeroiden yhdist&auml;minen
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="supported-paper-sizes-types-and-weights-chapter.html#supported-paper-sizes-types-and-weights-chapter_fi" title="Paperituki">
     Paperituki
    </a>
   </p>
   <div id="divd0e1660">
    <p class="toc-2-style">
     <a href="supported-paper-sizes-goldfinger-topic.html#supported-paper-sizes-goldfinger_fi" title="Tuetut paperikoot">
      Tuetut paperikoot
     </a>
    </p>
    <p class="toc-2-style">
     <a href="supported-paper-types-goldfinger-topic.html#supported-paper-types-goldfinger_fi" title="Tuetut paperilajit">
      Tuetut paperilajit
     </a>
    </p>
    <p class="toc-2-style">
     <a href="supported-paper-weights-goldfinger-topic.html#supported-paper-weights-goldfinger_fi" title="Tuetut paperien painot">
      Tuetut paperien painot
     </a>
    </p>
    <p class="toc-2-style">
     <a href="unacceptable-paper-topic.html#unacceptable-paper_fi" title="Kelpaamaton paperi">
      Kelpaamaton paperi
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-recycled-paper-topic.html#using-recycled-paper_fi" title="Uusiopaperin k&auml;ytt&auml;minen">
      Uusiopaperin k&auml;ytt&auml;minen
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="printing-chapter.html#printing-chapter_fi" title="Tulostaminen">
     Tulostaminen
    </a>
   </p>
   <div id="divd0e2519">
    <p class="toc-2-style">
     <a href="printing-from-computer-h2-topic.html#printing-from-computer-h2_fi" title="Tulostaminen tietokoneella">
      Tulostaminen tietokoneella
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-from-mobile-device-using-lexmark-print-topic.html#d0e2545" title="Tulostaminen mobiililaitteesta">
      Tulostaminen mobiililaitteesta
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-from-flash-drive-topic.html#printing-from-flash-drive_fi" title="Tulostaminen flash-asemasta">
      Tulostaminen flash-asemasta
     </a>
    </p>
    <p class="toc-2-style">
     <a href="supported-flash-drives-and-file-types-topic.html#supported-flash-drives-and-file-types_fi" title="Tuetut flash-asemat ja tiedostotyypit">
      Tuetut flash-asemat ja tiedostotyypit
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-confidential-jobs-topic.html#configuring-confidential-jobs_fi" title="Luottamuksellisten t&ouml;iden m&auml;&auml;ritt&auml;minen">
      Luottamuksellisten t&ouml;iden m&auml;&auml;ritt&auml;minen
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-confidential-and-other-held-jobs-topic.html#printing-confidential-and-other-held-jobs_fi" title="Luottamuksellisten ja muiden pidossa olevien t&ouml;iden tulostaminen">
      Luottamuksellisten ja muiden pidossa olevien t&ouml;iden tulostaminen
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-from-cloud-connector-profile-topic.html#printing-from-cloud-connector-profile_fi" title="Tulostaminen Cloud Connector -profiilista">
      Tulostaminen Cloud Connector -profiilista
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-font-sample-list-h2-topic.html#printing-font-sample-list-h2_fi" title="Fonttimalliluettelon tulostaminen">
      Fonttimalliluettelon tulostaminen
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-directory-list-h2-topic.html#printing-directory-list-h2_fi" title="Hakemistoluettelon tulostaminen">
      Hakemistoluettelon tulostaminen
     </a>
    </p>
    <p class="toc-2-style">
     <a href="canceling-print-job-topic.html#canceling-print-job_fi" title="Tulostusty&ouml;n peruuttaminen">
      Tulostusty&ouml;n peruuttaminen
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="understanding-printer-menus-chapter.html#understanding-printer-menus-chapter_fi" title="Tulostimen valikot">
     Tulostimen valikot
    </a>
   </p>
   <div id="divd0e3055">
    <p class="toc-2-style">
     <a href="menu-map-topic.html#menu-map_fi" title="Valikkokartta">
      Valikkokartta
     </a>
    </p>
    <p class="toc-2-style">
     <a href="preferences-topic.html#d0e3374" title="Laite">
      Laite
     </a>
    </p>
    <p class="toc-2-style">
     <a href="layout-topic.html#d0e5220" title="Tulosta">
      Tulosta
     </a>
    </p>
    <p class="toc-2-style">
     <a href="tray-configuration-topic.html#d0e6478" title="Paperi">
      Paperi
     </a>
    </p>
    <p class="toc-2-style">
     <a href="flash-drive-print-topic.html#d0e6740" title="USB-asema">
      USB-asema
     </a>
    </p>
    <p class="toc-2-style">
     <a href="network-overview-topic.html#d0e6961" title="Verkko/portit">
      Verkko/portit
     </a>
    </p>
    <p class="toc-2-style">
     <a href="login-methods-subgroup.html#d0e8751" title="Suojaus">
      Suojaus
     </a>
    </p>
    <p class="toc-2-style">
     <a href="menu-settings-page-topic.html#d0e9886" title="Raportit">
      Raportit
     </a>
    </p>
    <p class="toc-2-style">
     <a href="help-topic.html#help_fi" title="Ohje">
      Ohje
     </a>
    </p>
    <p class="toc-2-style">
     <a href="troubleshooting-menu-topic.html#d0e10134" title="vianm&auml;&auml;ritys">
      vianm&auml;&auml;ritys
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-menu-settings-page-topic.html#printing-menu-settings-page_fi" title="Valikkoasetussivun tulostus">
      Valikkoasetussivun tulostus
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="securing-the-printer.html#securing-the-printer_fi" title="Tulostimen suojaaminen">
     Tulostimen suojaaminen
    </a>
   </p>
   <div id="divd0e10186">
    <p class="toc-2-style">
     <a href="locating-security-slot-topic.html#locating-security-slot_fi" title="Turvalukon etsiminen">
      Turvalukon etsiminen
     </a>
    </p>
    <p class="toc-2-style">
     <a href="erasing-printer-memory-topic.html#erasing-printer-memory_fi" title="Tulostinmuistin tyhjent&auml;minen">
      Tulostinmuistin tyhjent&auml;minen
     </a>
    </p>
    <p class="toc-2-style">
     <a href="erasing-printer-hard-disk-memory-topic.html#erasing-printer-hard-disk-memory_fi" title="Tulostimen kiintolevyn tyhjent&auml;minen">
      Tulostimen kiintolevyn tyhjent&auml;minen
     </a>
    </p>
    <p class="toc-2-style">
     <a href="encrypting-printer-hard-disk-topic.html#encrypting-printer-hard-disk_fi" title="Tulostimen kiintolevyn salaaminen">
      Tulostimen kiintolevyn salaaminen
     </a>
    </p>
    <p class="toc-2-style">
     <a href="restoring-factory-default-settings-topic.html#restoring-factory-default-settings_fi" title="Oletusasetusten palautus">
      Oletusasetusten palautus
     </a>
    </p>
    <p class="toc-2-style">
     <a href="statement-of-volatility-h2-topic.html#statement-of-volatility-h2_fi" title="Haihtuvuusjulistus">
      Haihtuvuusjulistus
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="maintain-printer-chapter.html#maintain-printer-chapter_fi" title="Tulostimen yll&auml;pito">
     Tulostimen yll&auml;pito
    </a>
   </p>
   <div id="divd0e10400">
    <p class="toc-2-style">
     <a href="setting-up-e-mail-alert-topic.html#setting-up-e-mail-alert_fi" title="S&auml;hk&ouml;postih&auml;lytysten m&auml;&auml;ritt&auml;minen">
      S&auml;hk&ouml;postih&auml;lytysten m&auml;&auml;ritt&auml;minen
     </a>
    </p>
    <p class="toc-2-style">
     <a href="adjusting-default-headphone-volume-topic.html#adjusting-default-headphone-volume_fi" title="Kuulokkeiden oletus&auml;&auml;nenvoimakkuuden s&auml;&auml;t&auml;minen">
      Kuulokkeiden oletus&auml;&auml;nenvoimakkuuden s&auml;&auml;t&auml;minen
     </a>
    </p>
    <p class="toc-2-style">
     <a href="connecting-printer-to-wireless-network-topic.html#d0e10462" title="Verkkoyhteydet">
      Verkkoyhteydet
     </a>
    </p>
    <p class="toc-2-style">
     <a href="setting-up-serial-printing-topic.html#setting-up-serial-printing_fi" title="Sarjatulostuksen m&auml;&auml;ritt&auml;minen (koskee vain Windowsia)">
      Sarjatulostuksen m&auml;&auml;ritt&auml;minen (koskee vain Windowsia)
     </a>
    </p>
    <p class="toc-2-style">
     <a href="cleaning-printer-topic.html#cleaning-printer_fi" title="Tulostimen puhdistaminen">
      Tulostimen puhdistaminen
     </a>
    </p>
    <p class="toc-2-style">
     <a href="ordering-supplies-group.html#ordering-supplies-group_fi" title="Tulostimen osien ja tarvikkeiden tilaaminen">
      Tulostimen osien ja tarvikkeiden tilaaminen
     </a>
    </p>
    <p class="toc-2-style">
     <a href="replacing-toner-cartridge-topic.html#d0e11198" title="Tulostimen osien ja tarvikkeiden vaihtaminen">
      Tulostimen osien ja tarvikkeiden vaihtaminen
     </a>
    </p>
    <p class="toc-2-style">
     <a href="moving-the-printer-group.html#d0e11342" title="Tulostimen siirt&auml;minen">
      Tulostimen siirt&auml;minen
     </a>
    </p>
    <p class="toc-2-style">
     <a href="saving-energy-paper.html#d0e11398" title="Energian ja paperin s&auml;&auml;st&auml;minen">
      Energian ja paperin s&auml;&auml;st&auml;minen
     </a>
    </p>
    <p class="toc-2-style">
     <a href="recycling.html#d0e11502" title="Kierr&auml;tt&auml;minen">
      Kierr&auml;tt&auml;minen
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="clearing-jams-chapter.html#clearing-jams-chapter_fi" title="Tukosten poistaminen">
     Tukosten poistaminen
    </a>
   </p>
   <div id="divd0e11535">
    <p class="toc-2-style">
     <a href="avoiding-jams-topic.html#avoiding-jams_fi" title="Tukosten v&auml;ltt&auml;minen">
      Tukosten v&auml;ltt&auml;minen
     </a>
    </p>
    <p class="toc-2-style">
     <a href="identifying-jam-locations-topic.html#identifying-jam-locations_fi" title="Tukoksen sijainnin tunnistaminen">
      Tukoksen sijainnin tunnistaminen
     </a>
    </p>
    <p class="toc-2-style">
     <a href="paper-jam-in-door-a-topic.html#paper-jam-in-front-door_fi" title="Paperitukos luukussa A">
      Paperitukos luukussa A
     </a>
    </p>
    <p class="toc-2-style">
     <a href="paper-jam-in-rear-door-topic.html#paper-jam-in-rear-door_fi" title="Paperitukos takaluukussa">
      Paperitukos takaluukussa
     </a>
    </p>
    <p class="toc-2-style">
     <a href="paper-jam-in-standard-bin-topic.html#paper-jam-in-standard-bin_fi" title="Paperitukos vakiolokerossa">
      Paperitukos vakiolokerossa
     </a>
    </p>
    <p class="toc-2-style">
     <a href="paper-jam-in-duplex-unit-topic.html#paper-jam-in-duplex-unit_fi" title="Paperitukos arkink&auml;&auml;nt&auml;j&auml;ss&auml;">
      Paperitukos arkink&auml;&auml;nt&auml;j&auml;ss&auml;
     </a>
    </p>
    <p class="toc-2-style">
     <a href="message-paper-jam-trays-topic.html#message-paper-jam-trays_fi" title="Paperitukos lokeroissa">
      Paperitukos lokeroissa
     </a>
    </p>
    <p class="toc-2-style">
     <a href="message-paper-jam-mpf-topic.html#message-paper-jam-mpf_fi" title="Paperitukos monisy&ouml;tt&ouml;laitteessa">
      Paperitukos monisy&ouml;tt&ouml;laitteessa
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="troubleshooting-chapter.html#troubleshooting-chapter_fi" title="vianm&auml;&auml;ritys">
     vianm&auml;&auml;ritys
    </a>
   </p>
   <div id="divd0e11811">
    <p class="toc-2-style">
     <a href="trb-cannot-open-embedded-web-server-topic.html#d0e11814" title="Verkkoyhteysongelmat">
      Verkkoyhteysongelmat
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-cannot-detect-internal-option-topic.html#d0e12128" title="Lis&auml;varusteongelmat">
      Lis&auml;varusteongelmat
     </a>
    </p>
    <p class="toc-2-style">
     <a href="message-replace-cartridge-printer-region-mismatch-topic.html#d0e12402" title="Tarvikeongelmat">
      Tarvikeongelmat
     </a>
    </p>
    <p class="toc-2-style">
     <a href="solving-printer-problems.html#solving-printer-problems_fi" title="Paperinsy&ouml;tt&ouml;ongelmat">
      Paperinsy&ouml;tt&ouml;ongelmat
     </a>
    </p>
    <p class="toc-2-style">
     <a href="solving-printing-problems.html#solving-printing-problems_fi" title="Tulostusongelmat">
      Tulostusongelmat
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-contacting-customer-support-topic.html#trb-contacting-customer-support_fi" title="Yhteyden ottaminen asiakastukeen">
      Yhteyden ottaminen asiakastukeen
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="upgrading-migrating-chapter.html#upgrading-migrating-chapter_fi" title="P&auml;ivitt&auml;minen ja siirtyminen">
     P&auml;ivitt&auml;minen ja siirtyminen
    </a>
   </p>
   <div id="divd0e15394">
    <p class="toc-2-style">
     <a href="available-internal-options-topic.html#d0e15397" title="Laitteisto">
      Laitteisto
     </a>
    </p>
    <p class="toc-2-style">
     <a href="installing-printer-software-topic.html#d0e15707" title="Ohjelmisto">
      Ohjelmisto
     </a>
    </p>
    <p class="toc-2-style">
     <a href="exporting-importing-configuration-using-ews-winners-circle-topic.html#d0e15790" title="Laiteohjelma">
      Laiteohjelma
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="laser_ug_notices.html#laser_ug_notices_fi" title="Tiedotteet">
     Tiedotteet
    </a>
   </p>
   <div id="divd0e15876">
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e15879" title="Tuotetiedot">
      Tuotetiedot
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e15896" title="Painosta koskeva tiedote">
      Painosta koskeva tiedote
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#trademarks_fi" title="Tavaramerkit">
      Tavaramerkit
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#licensing-notices_fi" title="K&auml;ytt&ouml;oikeustiedote">
      K&auml;ytt&ouml;oikeustiedote
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#noise-emission-levels_fi" title="Emissiotaso">
      Emissiotaso
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#weee-directive_fi" title="S&auml;hk&ouml;- ja elektroniikkaromudirektiivi (SER)">
      S&auml;hk&ouml;- ja elektroniikkaromudirektiivi (SER)
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e16000" title="Environmental labeling for packaging">
      Environmental labeling for packaging
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#product-disposal_fi" title="Laitteen h&auml;vitt&auml;minen">
      Laitteen h&auml;vitt&auml;minen
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e16034" title="Litiumioniakku">
      Litiumioniakku
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#eu-battery-directive-2023-1542_fi" title="Asetus (EU) 2023/1542">
      Asetus (EU) 2023/1542
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#static-sensitivity-notice_fi" title="Staattista s&auml;hk&ouml;&auml; koskeva tiedote">
      Staattista s&auml;hk&ouml;&auml; koskeva tiedote
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#energy-star_fi" title="ENERGY STAR">
      ENERGY STAR
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#temperature-information_fi" title="L&auml;mp&ouml;tilatiedot">
      L&auml;mp&ouml;tilatiedot
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#laser-notice_fi" title="Laserilmoitus">
      Laserilmoitus
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#power-consumption_fi" title="Virrankulutus">
      Virrankulutus
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e16256" title="Langattomia tuotteita koskevat s&auml;&auml;nn&ouml;kset">
      Langattomia tuotteita koskevat s&auml;&auml;nn&ouml;kset
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#modular-component-notice_fi" title="Ilmoitus modulaarisista komponenteista">
      Ilmoitus modulaarisista komponenteista
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#exposure-to-radio-frequency-radiation_fi" title="Altistus radiotaajuuss&auml;teilylle">
      Altistus radiotaajuuss&auml;teilylle
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e16282" title="Euroopan yhteis&ouml;n (EY) direktiivien mukainen ilmoitus">
      Euroopan yhteis&ouml;n (EY) direktiivien mukainen ilmoitus
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#european-community-ec-directives-conformity-class-a_fi" title="Euroopan yhteis&ouml;n (EY) direktiivien mukainen ilmoitus">
      Euroopan yhteis&ouml;n (EY) direktiivien mukainen ilmoitus
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#radio-interference-notice_fi" title="Radioh&auml;iri&ouml;lausunto">
      Radioh&auml;iri&ouml;lausunto
     </a>
    </p>
   </div>
  </div>
 </div>
</template>
<script>
 import output from './output.json';

const fuzzysort = require('fuzzysort');
const lunr = require("lunr")
require("lunr-languages/lunr.stemmer.support.js")(lunr)
require('lunr-languages/lunr.multi')(lunr)
require("lunr-languages/tinyseg.js")(lunr)
require("lunr-languages/lunr.de.js")(lunr)
require("lunr-languages/lunr.es.js")(lunr)
require("lunr-languages/lunr.fr.js")(lunr)
require("lunr-languages/lunr.it.js")(lunr)
require("lunr-languages/lunr.ja.js")(lunr)
require("lunr-languages/lunr.pt.js")(lunr)

export default {
  name: 'app',
  data() {
    return {
        search: '',
        resultsActual: '',
        list: output,
        resultsCount: 0,
    }
  },

  methods: { queryResults() {

      if (this.search.trim() === ''){
        return  '';
      }
    //   else if(this.search.trim().length < 3){
    //     this.resultsActual = new Array();
    //     this.resultsCount = 0;
    //   }
      else {
        var documents = this.list;

        var idx = lunr(function () {
            this.use(lunr.ja);
            this.use(lunr.multiLanguage('en', 'de', 'es', 'fr', 'it', 'ja', 'pt'))
            this.ref('UUID');
            this.field('title');
            this.field('descFull');
            this.metadataWhitelist = ['position'];

            documents.forEach(function (doc) {
                        this.add(doc)
                    },this);
            });
        

        var searchTerms = this.search.replace(/[`~!#$%^&*()|+\-=?;:'",.<>\{\}\[\]\\/]/gi, ' ').trim().replace(/\s\s+/g, " ");
        // var searchTerms = this.search;
        searchTerms = this.removeStopWords(searchTerms);
        var searchRawTerms = searchTerms;
        // searchTerms  =  searchTerms.split(" ").join(" +");
        // searchTerms = searchTerms.startsWith(" +") ? searchTerms : "+" + searchTerms;

        console.log(searchTerms);
        var results = idx.search(searchTerms);

        console.log (results);

        results = results.map(res => {
            var linkRes =  documents.find(elem => elem.UUID == res.ref);
            var keywords_array = new Array();
            var keywords_arrays = new Array();
            var keywords_arrays_title = new Array();

            Object.keys(res.matchData.metadata).map(kys => {
                var positions_title = res.matchData.metadata[kys].title;
                var positions_desc = res.matchData.metadata[kys].descFull;

                if(typeof positions_title !== 'undefined' ){
                    positions_title.position.forEach(function(val, i, arr){
                        keywords_array.push(linkRes.descFull.substring(val[0],val[0] + val[1]));
                        keywords_arrays_title.push(val[0],val[1]);
                    });
                }

                if(typeof positions_desc !== 'undefined' ){
                    positions_desc.position.forEach(function(val, i, arr){
                        keywords_array.push(linkRes.descFull.substring(val[0],val[0] + val[1]));
                        keywords_arrays.push(val[0],val[1]);
                    });
                }
            });

            

            res.link = linkRes.link;
            res.desc = linkRes.desc;
            res.title = linkRes.title;
            res.full = linkRes.descFull;
            res.titleArray = keywords_arrays_title;
            res.descArray = keywords_arrays;
            keywords_array = keywords_array.filter(function(item, index){ 
                return searchRawTerms.indexOf(item) >= 0;
            });
            var keywords_set = new Set(keywords_array);
            res.keywords = [...keywords_set].toString();
            // res.keywords = ["ramon","joe","gudz"]
            return res;
        });
        
        var existingPagesInResult = new Array();
        

       
        results = results.filter(function(item, index){
                
            if(existingPagesInResult.includes(item.link)){
                
                return false;
            }
            else { 
                existingPagesInResult.push(item.link);
                return true;
            }

            if(res.keywords == ""){
                return false;
            }
        });

        

        console.log (results);
        this.resultsActual = results;
        this.resultsCount = results.length;
      }
    },

    clearResult: function(){
        this.search = "";
        this.resultsActual = undefined;
        this.resultsCount = 0;
        reload("cover.html", "");
       
    },  

    removeStopWords: function(queryString) {
        const stopWords = ['i', 'me', 'my', 'myself', 'we', 'our', 'ours', 'ourselves', 'you', "you're", "you've", "you'll", "you'd", 'your', 'yours', 'yourself', 'yourselves', 
        'he', 'him', 'his', 'himself', 'she', "she's", 'her', 'hers', 'herself', 'it', "it's", 'its', 'itself', 'they', 'them', 'their', 'theirs', 'themselves', 'what', 'which', 
        'who', 'whom', 'this', 'that', "that'll", 'these', 'those', 'am', 'is', 'are', 'was', 'were', 'be', 'been', 'being', 'have', 'has', 'had', 'having', 'do', 'does', 'did', 
        'doing', 'a', 'an', 'the', 'and', 'but', 'if', 'or', 'because', 'as', 'until', 'while', 'of', 'at', 'by', 'for', 'with', 'about', 'against', 'between', 'into', 'through', 
        'during', 'before', 'after', 'above', 'below', 'to', 'from', 'up', 'down', 'in', 'out', 'on', 'off', 'over', 'under', 'again', 'further', 'then', 'once', 'here', 'there', 
        'when', 'where', 'why', 'how', 'all', 'any', 'both', 'each', 'few', 'more', 'most', 'other', 'some', 'such', 'no', 'nor', 'not', 'only', 'own', 'same', 'so', 'than', 'too', 
        'very', 's', 't', 'can', 'will', 'just', 'don', "don't", 'should', "should've", 'now', 'd', 'll', 'm', 'o', 're', 've', 'y', 'ain', 'aren', "aren't", 'couldn', "couldn't", 
        'didn', "didn't", 'doesn', "doesn't", 'hadn', "hadn't", 'hasn', "hasn't", 'haven', "haven't", 'isn', "isn't", 'ma', 'mightn', "mightn't", 'mustn', "mustn't", 'needn', 
         "needn't", 'shan', "shan't", 'shouldn', "shouldn't", 'wasn', "wasn't", 'weren', "weren't", 'won', "won't", 'wouldn', "wouldn't"]

        var cleanQueryString = new Array();
        queryString.split(" ").forEach(word => {
             if(!stopWords.includes(word)) {
                 cleanQueryString.push(word);
             }
        });

        return cleanQueryString.join(" ");
    },
    
  }
}
</script>


// WEBPACK FOOTER //
// src/App.vue